import { useEffect } from 'react';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/nl';
import 'dayjs/locale/ru';
import 'dayjs/locale/uk';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/vi';
import 'dayjs/locale/ja';
import 'dayjs/locale/tr';
import 'dayjs/locale/id';
import 'dayjs/locale/ko';
import 'dayjs/locale/pl';
import 'dayjs/locale/es';
import 'dayjs/locale/it';
import 'dayjs/locale/pt';
import 'dayjs/locale/bg';

import { SUPPORTED_LOCALES, SUPPORTED_LOCALE_TYPE } from '@/locales';

import deLngJson from '@/locales/de/common.json';
import enLngJson from '@/locales/en/common.json';
import frLngJson from '@/locales/fr/common.json';
import nlLngJson from '@/locales/nl/common.json';
import ruLngJson from '@/locales/ru/common.json';
import ukLngJson from '@/locales/uk/common.json';
import zhCNLngJson from '@/locales/zh-cn/common.json';
import zhTwLngJson from '@/locales/zh-tw/common.json';
import viLngJson from '@/locales/vi/common.json';
import jaLngJson from '@/locales/ja/common.json';
import trLngJson from '@/locales/tr/common.json';
import idLngJson from '@/locales/id/common.json';
import koLngJson from '@/locales/ko/common.json';
import plLngJson from '@/locales/pl/common.json';
import esLngJson from '@/locales/es/common.json';
import itLngJson from '@/locales/it/common.json';
import ptLngJson from '@/locales/pt/common.json';
import bgLngJson from '@/locales/bg/common.json';

const defaultLng = 'en';

const resources = {
  resources: {
    de: { common: deLngJson },
    en: { common: enLngJson },
    fr: { common: frLngJson },
    nl: { common: nlLngJson },
    ru: { common: ruLngJson },
    uk: { common: ukLngJson },
    'zh-cn': { common: zhCNLngJson },
    'zh-tw': { common: zhTwLngJson },
    vi: { common: viLngJson },
    ja: { common: jaLngJson },
    tr: { common: trLngJson },
    id: { common: idLngJson },
    ko: { common: koLngJson },
    pl: { common: plLngJson },
    es: { common: esLngJson },
    it: { common: itLngJson },
    pt: { common: ptLngJson },
    bg: { common: bgLngJson },
  },
};

const I18N_NS = 'common';

let initFn = i18n.use(initReactI18next);

initFn.init({
  fallbackLng: defaultLng,
  ns: [I18N_NS],
  defaultNS: I18N_NS,
  lowerCaseLng: true,
  supportedLngs: SUPPORTED_LOCALES.filter(x => x.key).map(x => x.key),
  ...resources,
});

dayjs.locale(defaultLng);

export const useSyncI18n = (lng?: SUPPORTED_LOCALE_TYPE) => {
  useEffect(() => {
    dayjs.locale(lng || defaultLng);
    i18n.changeLanguage(lng || defaultLng);
  }, [lng]);
};

export { i18n as richEditorI18n };
